
export const sendDataLayer = (event, value) => {
    window.dataLayer.push({event : value})
    console.log(window.dataLayer);
}